<template>
  <footer>
    <div class="block cmi-footer">
      <div class="container">
        <div class="row">
          <div class="col-md-4">
            <router-link to="/" :exact="true">
              <img
                class="img-responsive cmi-footer-logo"
                src="/dist/assets/logos/cfmchurch_logo_001.png"
                alt="CFM CHURCH LOGO AND TEXT"
              />
            </router-link>
          </div>
          <div id="contact" class="col-md-4">
            <h3 class="cmi-contact-h">CONTACTS</h3>
            <div class="widget">
              <div class="about">
                <div class="contact cmi-footer-text">
                  <ul>
                    <li>
                      <span class="cmi-contact-span"
                        ><i class="fa fa-phone"></i>Mobile : </span
                      >07723 363 184
                    </li>
                    <li>
                      <span class="cmi-contact-span"
                        ><i class="fa fa-envelope"></i>E-mail : </span
                      >info@christlifefaithministries.org
                    </li>
                    <li>
                      <span class="cmi-contact-span"
                        ><i class="fa fa-home"></i>Address : </span
                      ><br />
                      87 Clarendon Street<br />
                      Leicester<br />
                      LE2 7FH<br />
                      United Kingdom<br />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="cmi-quick-links">
              <account></account>
            </div>
            <div class="widget">
              <div class="about">
                <ul class="social-media">
                  <li>
                    <a
                      title="CFM CHURCH Facebook"
                      href="https://www.facebook.com/christlifefaithministries.org"
                      target="_blank"
                      ><i class="fa fa-facebook"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      title="CHRISTLIFE FAITH MINISTRIES YouTube"
                      href="https://www.youtube.com/@christlifefaithministriesc5100/streams"
                      target="_blank"
                    >
                      <i class="fa fa-youtube"></i>
                    </a>
                  </li>
                  <li>
                    <a href="javascript:void(0);" title=""
                      ><i class="fa fa-linkedin"></i
                    ></a>
                  </li>
                  <li>
                    <a href="javascript:void(0);" title=""
                      ><i class="fa fa-google-plus"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import Account from "./UserAccount";
export default {
  components: {
    Account
  },
  data() {
    return {};
  }
};
</script>
